import { render, staticRenderFns } from "./inkoop.vue?vue&type=template&id=18fe9a1d&scoped=true"
import script from "./inkoop.vue?vue&type=script&lang=js"
export * from "./inkoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe9a1d",
  null
  
)

export default component.exports